export const TITLE_MAX_LENGTH = 60;
export const SUBTITLE_MAX_LENGTH = 120;
export const PRETEXT_MAX_LENGTH = 60;

export const DATE_TIME_PATTERN = /^\d{4}-\d{2}-\d{2}:\d{2}-\d{2}-\d{2}$/;
export const DATE_TIME_PLACEHOLDER = 'YYYY-MM-DD:HH-mm-ss';
